var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutMethodologiesBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1520px",
    height: "792.455px",
    viewBox: "0 0 1520 792.455",
    enableBackground: "new 0 0 1520 792.455",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 161.76,
    cy: 211.878,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 348.889,
    cy: 211.878,
    r: 3.571
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 312.726,
    cy: 322.339,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 133.186,
    cy: 328.554,
    r: 3.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M334.669,227.393 c0,1.973-1.599,3.57-3.573,3.57c-1.969,0-3.569-1.598-3.569-3.57c0-1.972,1.601-3.569,3.569-3.569 C333.07,223.823,334.669,225.421,334.669,227.393z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 378.424,
    cy: 328.554,
    r: 3.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M248.335,358.736 c0,1.973-1.599,3.57-3.569,3.57c-1.972,0-3.572-1.598-3.572-3.57c0-1.968,1.6-3.569,3.572-3.569 C246.736,355.167,248.335,356.769,248.335,358.736z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 117.421,
    cy: 403.202,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 70.336,
    cy: 479.771,
    r: 3.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M164.863,528.418 c0,1.973-1.598,3.573-3.57,3.573s-3.57-1.601-3.57-3.573c0-1.969,1.598-3.565,3.57-3.565S164.863,526.449,164.863,528.418z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 84.659,
    cy: 527.01,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 255.609,
    cy: 479.771,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 254.876,
    cy: 555.741,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 234.421,
    cy: 457.463,
    r: 3.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M427.978,478.437 c0,1.973-1.598,3.573-3.57,3.573c-1.97,0-3.569-1.601-3.569-3.573c0-1.969,1.599-3.569,3.569-3.569 C426.38,474.867,427.978,476.468,427.978,478.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M368.208,528.418 c0,1.973-1.599,3.573-3.569,3.573c-1.972,0-3.57-1.601-3.57-3.573c0-1.969,1.598-3.565,3.57-3.565 C366.608,524.853,368.208,526.449,368.208,528.418z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 395.99,
    cy: 452.074,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 405.51,
    cy: 422.316,
    r: 3.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M356.269,397.416c0,1.973-1.598,3.57-3.57,3.57 c-1.97,0-3.569-1.598-3.569-3.57c0-1.968,1.599-3.569,3.569-3.569C354.671,393.847,356.269,395.448,356.269,397.416z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 166.274,
    cy: 396.063,
    r: 3.57
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M260.979,358.736 c0,1.973-1.599,3.57-3.569,3.57s-3.57-1.598-3.57-3.57c0-1.968,1.6-3.569,3.57-3.569S260.979,356.769,260.979,358.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M260.979,413.74 c0,1.968-1.599,3.569-3.569,3.569s-3.57-1.602-3.57-3.569c0-1.973,1.6-3.573,3.57-3.573S260.979,411.768,260.979,413.74z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 226.815,
    cy: 295.452,
    r: 3.571
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 233.955,
    cy: 227.393,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 145.222,
    cy: 277.31,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 182.318,
    cy: 342.271,
    r: 3.57
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1B75BB",
    stroke: "#1B75BB",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 351.004,
    cy: 249.527,
    r: 3.57
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 115.82,452.074 115.82,556.032 91.666,549.581 70.335,528.418 63.838,504.053 70.174,479.197 95.554,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 70.174,479.197 99.858,478.437 115.915,479.688 63.551,504.526 115.174,530.016 84.543,528.186 115.915,504.104 95.554,457.084  78.841,503.894 84.367,528.276 91.666,549.581 115.53,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 95.843,
    cy: 457.463,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 70.563,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 116.009,
    cy: 479.771,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 82.218,
    cy: 496.056,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 84.658,
    cy: 527.843,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 115.276,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 70.337,
    cy: 528.418,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 115.619,
    cy: 503.515,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 100.031,
    cy: 478.633,
    r: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3077B9",
    d: "M102.034,542.479c0,0.782-0.631,1.411-1.412,1.411c-0.779,0-1.41-0.629-1.41-1.411 c0-0.779,0.631-1.412,1.41-1.412C101.403,541.066,102.034,541.699,102.034,542.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 115.82,452.074 115.82,556.032 91.666,549.581 70.335,528.418 63.838,504.053 70.174,479.197 95.554,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 70.174,479.197 99.858,478.437 115.915,479.688 63.551,504.526 115.174,530.016 84.543,528.186 115.915,504.104 95.554,457.084  78.841,503.894 84.367,528.276 91.666,549.581 115.53,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 95.843,
    cy: 457.463,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 70.563,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 116.009,
    cy: 479.771,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 82.218,
    cy: 496.056,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 84.658,
    cy: 527.843,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 115.276,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 70.337,
    cy: 528.418,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 115.619,
    cy: 503.515,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 100.031,
    cy: 478.633,
    r: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M102.034,542.479 c0,0.782-0.631,1.411-1.412,1.411c-0.779,0-1.41-0.629-1.41-1.411c0-0.779,0.631-1.412,1.41-1.412 C101.403,541.066,102.034,541.699,102.034,542.479z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 115.811,452.074 115.811,556.032 139.963,549.581 161.293,528.418 167.79,504.053 161.457,479.197 136.077,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 161.457,479.197 131.77,478.437 115.716,479.688 168.077,504.526 116.455,530.016 147.085,528.186 115.716,504.104  136.077,457.084 152.789,503.894 147.262,528.276 139.963,549.581 116.098,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 135.786,
    cy: 457.463,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 161.067,
    cy: 479.215,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 115.619,
    cy: 479.771,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 149.411,
    cy: 496.056,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 146.971,
    cy: 527.843,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 116.354,
    cy: 555.741,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 161.293,
    cy: 528.418,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 116.009,
    cy: 503.515,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 131.598,
    cy: 478.633,
    r: 1.411
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3077B9",
    d: "M129.594,542.479c0,0.782,0.633,1.411,1.412,1.411c0.781,0,1.412-0.629,1.412-1.411 c0-0.779-0.631-1.412-1.412-1.412C130.227,541.066,129.594,541.699,129.594,542.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 115.811,452.074 115.811,556.032 139.963,549.581 161.293,528.418 167.79,504.053 161.457,479.197 136.077,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 161.457,479.197 131.77,478.437 115.716,479.688 168.077,504.526 116.455,530.016 147.085,528.186 115.716,504.104  136.077,457.084 152.789,503.894 147.262,528.276 139.963,549.581 116.098,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 135.786,
    cy: 457.463,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 161.067,
    cy: 479.215,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 115.619,
    cy: 479.771,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 149.411,
    cy: 496.056,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 146.971,
    cy: 527.843,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 116.354,
    cy: 555.741,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 161.293,
    cy: 528.418,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 116.009,
    cy: 503.515,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 131.598,
    cy: 478.633,
    r: 1.411
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M129.594,542.479 c0,0.782,0.633,1.411,1.412,1.411c0.781,0,1.412-0.629,1.412-1.411c0-0.779-0.631-1.412-1.412-1.412 C130.227,541.066,129.594,541.699,129.594,542.479z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 255.809,452.074 255.809,556.032 231.655,549.581 210.327,528.418 203.83,504.053 210.163,479.197 235.542,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 210.163,479.197 239.85,478.437 255.904,479.688 203.542,504.526 255.163,530.016 224.534,528.186 255.904,504.104  235.542,457.084 218.831,503.894 224.357,528.276 231.655,549.581 255.521,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 235.832,
    cy: 457.463,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 210.552,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 255.999,
    cy: 479.771,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 222.206,
    cy: 496.056,
    r: 1.413
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 224.648,
    cy: 527.843,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 255.265,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 210.327,
    cy: 528.418,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 255.61,
    cy: 503.515,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 240.021,
    cy: 478.633,
    r: 1.411
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3077B9",
    d: "M242.024,542.479c0,0.782-0.631,1.411-1.41,1.411c-0.781,0-1.412-0.629-1.412-1.411 c0-0.779,0.631-1.412,1.412-1.412C241.393,541.066,242.024,541.699,242.024,542.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 255.809,452.074 255.809,556.032 231.655,549.581 210.327,528.418 203.83,504.053 210.163,479.197 235.542,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 210.163,479.197 239.85,478.437 255.904,479.688 203.542,504.526 255.163,530.016 224.534,528.186 255.904,504.104  235.542,457.084 218.831,503.894 224.357,528.276 231.655,549.581 255.521,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 235.832,
    cy: 457.463,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 210.552,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 255.999,
    cy: 479.771,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 222.206,
    cy: 496.056,
    r: 1.413
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 224.648,
    cy: 527.843,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 255.265,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 210.327,
    cy: 528.418,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 255.61,
    cy: 503.515,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 240.021,
    cy: 478.633,
    r: 1.411
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M242.024,542.479 c0,0.782-0.631,1.411-1.41,1.411c-0.781,0-1.412-0.629-1.412-1.411c0-0.779,0.631-1.412,1.412-1.412 C241.393,541.066,242.024,541.699,242.024,542.479z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 255.8,452.074 255.8,556.032 279.954,549.581 301.282,528.418 307.779,504.053 301.444,479.197 276.066,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 301.444,479.197 271.759,478.437 255.706,479.688 308.067,504.526 256.446,530.016 287.075,528.186 255.706,504.104  276.066,457.084 292.779,503.894 287.251,528.276 279.954,549.581 256.087,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 275.776,
    cy: 457.463,
    r: 1.413
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 301.057,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 255.61,
    cy: 479.771,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 289.4,
    cy: 496.056,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 286.96,
    cy: 527.843,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 256.344,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 301.281,
    cy: 528.418,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 255.999,
    cy: 503.515,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 271.589,
    cy: 478.633,
    r: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3077B9",
    d: "M269.583,542.479c0,0.782,0.633,1.411,1.412,1.411c0.781,0,1.412-0.629,1.412-1.411 c0-0.779-0.631-1.412-1.412-1.412C270.217,541.066,269.583,541.699,269.583,542.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 255.8,452.074 255.8,556.032 279.954,549.581 301.282,528.418 307.779,504.053 301.444,479.197 276.066,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 301.444,479.197 271.759,478.437 255.706,479.688 308.067,504.526 256.446,530.016 287.075,528.186 255.706,504.104  276.066,457.084 292.779,503.894 287.251,528.276 279.954,549.581 256.087,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 275.776,
    cy: 457.463,
    r: 1.413
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 301.057,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 255.61,
    cy: 479.771,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 289.4,
    cy: 496.056,
    r: 1.41
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 286.96,
    cy: 527.843,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 256.344,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 301.281,
    cy: 528.418,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 255.999,
    cy: 503.515,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 271.589,
    cy: 478.633,
    r: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M269.583,542.479 c0,0.782,0.633,1.411,1.412,1.411c0.781,0,1.412-0.629,1.412-1.411c0-0.779-0.631-1.412-1.412-1.412 C270.217,541.066,269.583,541.699,269.583,542.479z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 395.798,452.074 395.798,556.032 371.645,549.581 350.316,528.418 343.817,504.053 350.152,479.197 375.532,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 350.152,479.197 379.837,478.437 395.893,479.688 343.532,504.526 395.154,530.016 364.523,528.186 395.893,504.104  375.532,457.084 358.82,503.894 364.347,528.276 371.645,549.581 395.511,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 375.822,
    cy: 457.463,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 350.542,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 395.99,
    cy: 479.771,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 362.197,
    cy: 496.056,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 364.638,
    cy: 527.843,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 395.254,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 350.316,
    cy: 528.418,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 395.599,
    cy: 503.515,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 380.011,
    cy: 478.633,
    r: 1.411
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3077B9",
    d: "M382.015,542.479c0,0.782-0.633,1.411-1.412,1.411c-0.78,0-1.412-0.629-1.412-1.411 c0-0.779,0.631-1.412,1.412-1.412C381.382,541.066,382.015,541.699,382.015,542.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 395.798,452.074 395.798,556.032 371.645,549.581 350.316,528.418 343.817,504.053 350.152,479.197 375.532,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 350.152,479.197 379.837,478.437 395.893,479.688 343.532,504.526 395.154,530.016 364.523,528.186 395.893,504.104  375.532,457.084 358.82,503.894 364.347,528.276 371.645,549.581 395.511,530.201  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 375.822,
    cy: 457.463,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 350.542,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 395.99,
    cy: 479.771,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 362.197,
    cy: 496.056,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 364.638,
    cy: 527.843,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 395.254,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 350.316,
    cy: 528.418,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 395.599,
    cy: 503.515,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 380.011,
    cy: 478.633,
    r: 1.411
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M382.015,542.479 c0,0.782-0.633,1.411-1.412,1.411c-0.78,0-1.412-0.629-1.412-1.411c0-0.779,0.631-1.412,1.412-1.412 C381.382,541.066,382.015,541.699,382.015,542.479z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 395.789,452.074 395.789,556.032 419.943,549.581 441.273,528.418 447.769,504.053 441.437,479.197 416.055,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeWidth: 0.7452,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 448.06,504.526 396.435,530.016 427.064,528.186 395.695,504.104 416.055,457.084 432.768,503.894 427.243,528.276  419.943,549.581 396.075,530.201  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.669,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 441.437,479.197 411.75,478.437 395.695,479.688  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 415.765,
    cy: 457.463,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 441.048,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 395.599,
    cy: 479.771,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 429.39,
    cy: 496.056,
    r: 1.413
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 426.949,
    cy: 527.843,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 396.333,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 441.273,
    cy: 528.418,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 395.99,
    cy: 503.515,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3077B9",
    cx: 411.578,
    cy: 478.633,
    r: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3077B9",
    d: "M409.575,542.479c0,0.782,0.629,1.411,1.412,1.411c0.779,0,1.41-0.629,1.41-1.411 c0-0.779-0.631-1.412-1.41-1.412C410.204,541.066,409.575,541.699,409.575,542.479z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 395.789,452.074 395.789,556.032 419.943,549.581 441.273,528.418 447.769,504.053 441.437,479.197 416.055,457.084  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 448.06,504.526 396.435,530.016 427.064,528.186 395.695,504.104 416.055,457.084 432.768,503.894 427.243,528.276  419.943,549.581 396.075,530.201  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 441.437,479.197 411.75,478.437 395.695,479.688  "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 415.765,
    cy: 457.463,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 441.048,
    cy: 479.215,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 395.599,
    cy: 479.771,
    r: 1.411
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 429.39,
    cy: 496.056,
    r: 1.413
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 426.949,
    cy: 527.843,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 396.333,
    cy: 555.741,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 441.273,
    cy: 528.418,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 395.99,
    cy: 503.515,
    r: 1.412
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 411.578,
    cy: 478.633,
    r: 1.412
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M409.575,542.479 c0,0.782,0.629,1.411,1.412,1.411c0.779,0,1.41-0.629,1.41-1.411c0-0.779-0.631-1.412-1.41-1.412 C410.204,541.066,409.575,541.699,409.575,542.479z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 116.098,452.074 116.098,402.351 257.756,402.351 255.809,452.074  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 260.834,384.986 396.075,402.351 387.051,430.715 396.075,452.074 396.075,402.351 257.756,402.351 257.756,358.736  245.688,385.357 215.583,402.351 165.729,396.674 155.16,402.351 301.444,390.775 330.463,401.604 351.058,396.831  395.254,427.214 377.233,457.463  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 116.098,448.978 126.76,434.434 116.098,402.351 257.021,384.499 260.834,384.986  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 275.776,457.463 242.024,402.351 273,402.351 257.756,414.194 235.833,457.463  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 135.787,457.463 126.76,434.434 95.843,457.463 116.098,402.351  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 396.075,402.351 405.472,423.641 395.254,427.214 415.766,457.463 404.892,423.561  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1B75BB",
    strokeMiterlimit: 10,
    d: "M65.309,498.278l-49.064,28.43 c-16.404,9.504-16.302,33.226,0.182,42.588L214.18,681.638c7.507,4.265,16.698,4.272,24.212,0.025l228.742-129.364 c7.62-4.308,16.96-4.231,24.511,0.196l101.308,93.553h343.871l316.087-211.858c15.705-9.198,16.287-31.693,1.081-41.692 l-64.723-42.563c-15.155-9.963-14.642-32.352,0.946-41.616l115.301-68.51c15.355-9.126,16.138-31.067,1.474-41.264l-101.029-70.22 c-7.802-5.422-18.033-5.858-26.265-1.113l-116.498,67.108c-8.358,4.818-18.765,4.29-26.595-1.35l-90.066-64.835 c-7.933-5.713-18.5-6.171-26.898-1.176L721.627,244.808c-7.678,4.567-17.233,4.607-24.947,0.095l-204.751-119.71 c-7.732-4.52-17.317-4.473-25.005,0.134l-143.833,86.151"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 349.85,211.878 259.73,211.878 251.883,211.878 161.761,211.878 133.186,240.449 133.186,329.03 162.574,358.42 251.883,358.42  259.73,358.42 349.033,358.42 378.423,329.03 378.423,240.449  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 329.938,227.393 258.898,227.393 252.712,227.393 181.673,227.393 159.15,249.917 159.15,319.736 182.317,342.904  252.712,342.904 258.898,342.904 329.292,342.904 352.459,319.736 352.459,249.917  "
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 180.764,
    y1: 342.271,
    x2: 244.766,
    y2: 358.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 161.761,211.878 181.673,227.393 133.186,240.449 159.15,319.736 162.574,358.42 182.317,342.904 133.186,329.03  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 329.292,342.904 359.886,347.184 378.423,240.449 329.938,227.393 359.886,222.113 352.459,249.917 378.423,329.03  352.459,319.736 349.033,358.42 206.039,342.978 162.574,358.42  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 349.85,211.878 329.938,227.393 254.13,212.485 234.47,227.051 161.761,211.878  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#1B75BB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 159.15,249.917 329.938,227.393 352.459,319.736 182.317,342.904 234.47,227.051 329.292,342.904 159.15,319.736  352.459,249.917 159.15,272.866 340.497,331.701 255.804,342.271 181.673,227.393  "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutMethodologiesBg);
export default __webpack_public_path__ + "static/media/aboutMethodologiesBg.6f18d82a4190f06370a0df833717505d.svg";
export { ForwardRef as ReactComponent };